export enum ApplicationType {
  tiered = 'Tiered',
  flatRate = 'Flat Rate',
  cashDiscount = 'Cash Discount',
  interchange = 'Interchange',
  interchangeEBTMonthly = 'Interchange with EBT Monthly',
  err = 'ERR',
  cnpVCp = 'CNP v CP',
  surcharge = 'Surcharge',
  dualPricing = 'Dual Pricing', // DEPRECATED
  dualPricingPassThroughFees = 'Dual Pricing Credit w/PIN Debit Pass-through Fees', // Old "Dual Pricing"
  dualPricingPassThroughFeesEBTMonthly = 'Dual Pricing Credit w/PIN Debit PT and EBT Monthly',
  dualPricingFlatRate = 'Dual Pricing w/PIN Debit Flat Rate',
  dualPricingFlatRateEBTMonthly = 'Dual Pricing w/PIN Debit Flat Rate and EBT Monthly',
}

export const isEBTMonthly = (applicationType: ApplicationType) => {
  return [
    ApplicationType.interchangeEBTMonthly,
    ApplicationType.dualPricingFlatRateEBTMonthly,
    ApplicationType.dualPricingPassThroughFeesEBTMonthly,
  ].includes(applicationType);
};
